'use client';

import React, { useRef } from 'react';
import styles from './HIPAACompliance.module.css';
import { Container } from '../..';
import SecurityLogo from './SecurityLogo';

const Section = React.forwardRef<
  HTMLElement,
  React.HTMLAttributes<HTMLElement>
>(({ className, children, ...props }, ref) => (
  <section
    ref={ref}
    className={className ? `${styles.section} ${className}` : styles.section}
    {...props}
  >
    {children}
  </section>
));

Section.displayName = 'Section';

const Wrapper = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.wrapper}>{children}</div>
);

const InnerContainer = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.innerContainer}>{children}</div>
);

const IconWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.iconWrapper}>{children}</div>
);

const TextWrapper = ({ children }: { children: React.ReactNode }) => (
  <div className={styles.textWrapper}>{children}</div>
);

const Title = ({ children }: { children: React.ReactNode }) => (
  <h2 className={styles.title}>{children}</h2>
);

const Subtitle = ({ children }: { children: React.ReactNode }) => (
  <p className={styles.subtitle}>{children}</p>
);

interface HIPAAComplianceProps {
  className?: string;
  htmlId?: string;
}

const HIPAACompliance = ({ className, htmlId }: HIPAAComplianceProps) => {
  const rootRef = useRef<HTMLElement>(null);

  return (
    <Section
      className={className}
      id={htmlId}
      ref={rootRef}
      aria-label="HIPAA Compliance section"
    >
      <Wrapper>
        <Container>
          <InnerContainer>
            <IconWrapper>
              <SecurityLogo />
            </IconWrapper>
            <TextWrapper>
              <Title>All your data is completely secure & private</Title>
              <Subtitle>
                Home is HIPAA & GDPR compliant to ensure sleep data is
                protected. It also features a physical microphone cut-off
                option and the audio data from the Home monitor is auto-deleted
                after two days.
              </Subtitle>
            </TextWrapper>
          </InnerContainer>
        </Container>
      </Wrapper>
    </Section>
  );
};

export default HIPAACompliance;
